import isArray from 'lodash/isArray';
import set from 'lodash/set';

/**
 * Map incoming data to new object based on supplied mapping transform
 *
 * @param {object} data - data to map
 * @param {object} mappings - where to place in the new object
 * @returns {object}
 */
export default (data, mappings) => {
  const transform = {};

  Object.entries(data).forEach(([key, value]) => {
    const mapping = mappings[key];
    if (!mapping) {
      return;
    }
    if (isArray(mapping)) {
      mapping.forEach(item => {
        set(transform, item, value);
      });
    } else {
      set(transform, mapping, value);
    }
  });

  return transform;
};
